"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGoogleAPIFragment = exports.STATIC_MARKER_URL3X = exports.STATIC_MARKER_URL2X = exports.STATIC_MARKER_URL = void 0;
var createGoogleAPIFragment = exports.createGoogleAPIFragment = function createGoogleAPIFragment(googleKey) {
  return "https://maps.googleapis.com/maps/api/staticmap?key=".concat(googleKey);
};
var STATIC_MARKER_URL = exports.STATIC_MARKER_URL = 'https://uniteus-io-assets.s3.amazonaws.com/app-client/location-marker.png';
var STATIC_MARKER_URL2X = exports.STATIC_MARKER_URL2X = 'https://uniteus-io-assets.s3.amazonaws.com/app-client/location-marker-2x.png';
var STATIC_MARKER_URL3X = exports.STATIC_MARKER_URL3X = 'https://uniteus-io-assets.s3.amazonaws.com/app-client/location-marker-3x.png';